module.exports = __webpack_public_path__ + "img/waterfall-poster.9368a30.jpg";